// extracted by mini-css-extract-plugin
module.exports = {"graphqlsamples":"GraphQLSamples_graphqlsamples__wFgNy"};